<template>
  <div class="SaleIndexPaneContainer">
    <nut-row class="bothCenter mt8 ft14">
      <nut-col :span="16" class="leftCenter">
        <span style="color: #3D92FD">现已支持分享本页链接</span>
      </nut-col>
      <nut-col :span="8" class="rightCenter">
        <span style="color: #3D92FD" class="techColor ft18" @click="shareCategory">立即分享</span>
        <nut-icon color="#3D92FD" size="16" class="ml8" name="share-n"></nut-icon>
      </nut-col>
    </nut-row>
    <nut-row>
      <template v-for="(s,si) in secondCategories" :key="`categories_${si}`">
        <nut-tag class="mr6" :plain="activeTab != si" type="warning" @click="chooseSecondCategory(s,si)">{{ s.label }}</nut-tag>
      </template>
    </nut-row>
    <!--          <nut-input style="background: #F7F7F7"-->
    <!--                     :border="false" class="brd6"-->
    <!--                     left-icon="search" placeholder="搜索商品名"/>-->
    <InfiniteLoadingList :query-id="1" :init-query="{categoryId:t.value,secondCategory:secondCategory?.id}">
      <template v-slot="data">
        <SaleItemCard :data="data.data" @click="getAgentSaleId(data.data)"/>
      </template>
    </InfiniteLoadingList>
  </div>
</template>

<script>
import SaleItemCard from "@/components/sale/SaleItemCard.vue";
import InfiniteLoadingList from "@/components/InfiniteLoadingList.vue";
import {Toast} from "@nutui/nutui";
import api from "@/api";

export default {
  name: "SaleIndexPane",
  components: {InfiniteLoadingList, SaleItemCard},
  props: {
    ti: {
      type: Number,
      default: 0
    },
    t: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      secondCategories: [],
      activeTab: -1,
      secondCategory:null,
    }
  },
  methods: {
    chooseSecondCategory(s, si) {
      if (this.activeTab == si) {
        this.activeTab = -1;
        this.secondCategory = null;
      } else {
        this.activeTab = si;
        this.secondCategory = s;
      }
    },
    getAgentSaleId(d) {
      api.getAgentSaleId(d.id)
          .then(ret => {
            this.$router.push('/d/' + ret)
          })
    },
    shareCategory() {
      Toast.text('由于微信限制，请点击右上角直接分享新页面')
      if(this.secondCategory){
        this.$router.push('/share/' + this.secondCategory.shareToken);
      }else{
        this.$router.push('/share/' + this.t.shareToken);
      }
    },
    init() {
      api.getEnumOptions({
        type: 0,
        refId: this.t.value,
      }).then(ret => {
        this.secondCategories.push(...ret)
      })
    }
  },
  mounted() {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.SaleIndexPaneContainer {
  display: flex;
  flex-direction: column;
  background-color: white;
}
</style>